import { datetimeFormatter } from 'utils/datetime';

export const usersTableColumns = [
  { field: 'display_name', label: 'User Name' },
  { field: 'email', label: 'Email' },
  { field: 'role_in_string', label: 'Role' },
  { field: 'lastmoddate', label: 'Updated Date', formatter: datetimeFormatter },
];
